<script>
    // Logic 
    import GraphCard from '../cards/GraphCard.svelte';
    import {getSUS} from '../../utils/apiNew';

    // Components 

    // Bindings 
    const susPromise = getSUS();
    export let viewRespirator = true;

</script> 
<div class="sa-app-container my-4">
    {#await susPromise then sus}
        <GraphCard title="Innlagte på SUS" subtitle="" susAll={sus.all} {viewRespirator}></GraphCard>
    {/await}
</div>



<style lang='scss'>

</style>